import React from "react";
import { DefaultForm } from "./style";
export const Form = ({ onSubmit, children, className, ...props }) => {
  return (
    <DefaultForm className={className} onSubmit={onSubmit}>
      {children}
    </DefaultForm>
  );
};
